<template>
  <div class="auto-reply-page">
    <!-- 自定义胶囊式tab切换栏（新增下划线结构） -->
    <div class="custom-tabs">
      <div
        class="tab-item"
        :class="{ active: activeTab === 'keyword' }"
        @click="activeTab = 'keyword'"
      >
        <span class="tab-text">关键词回复</span>
        <!-- 选中态下划线 -->
        <div class="tab-underline" v-show="activeTab === 'keyword'"></div>
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'follow' }"
        @click="activeTab = 'follow'"
      >
        <span class="tab-text">被关注回复</span>
        <!-- 选中态下划线 -->
        <div class="tab-underline" v-show="activeTab === 'follow'"></div>
      </div>
    </div>

    <!-- 关键词回复内容区 -->
    <div class="tab-content" v-show="activeTab === 'keyword'">
      <!-- 开关和描述 -->
      <div>
        <h2>关键词回复</h2>
        <div class="reply-header">
          <div class="reply-desc">
            <span
              >通过编辑内容或关键词规则，快速进行自动回复设置。如具备开发能力，可更灵活地使用该功能</span
            >
            <el-button
              type="text"
              size="small"
              class="custom-btn none"
              style="margin-left: 20px"
              >了解更多</el-button
            >
          </div>
          <el-switch
            v-model="keywordEnabled"
            active-text=""
            inactive-text=""
          ></el-switch>
        </div>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="search-input">
          <span>关键词：</span>
          <el-input
            v-model="keywordSearch"
            placeholder="请输入"
            style="width: 200px"
          ></el-input>
          <el-button
            type="primary"
            size="small"
            @click="handleClick('left', '搜索')"
            style="margin-left: 10px"
            >搜索</el-button
          >
          <el-button
            type="default"
            size="small"
            @click="handleClick('left', '重置')"
            >重置</el-button
          >
        </div>
        <div class="search-buttons">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            plain
            @click="handleClick('right', '新增')"
            >新增</el-button
          >
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            @click="handleClick('right', '删除')"
            >删除</el-button
          >
        </div>
      </div>

      <!-- 规则列表 -->

      <CustomTable
        :tableData="tableData"
        :tableHeaders="tableHeaders"
        :showSelection="true"
        :pagination="pagination"
        :loading="tableLoading"
        tableHeight="calc(100vh - 255px)"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #action="{ row }">
          <div class="action-buttons">
            <el-button
              v-for="button in actionButtons.tableArticleButtons"
              :key="button.id"
              v-if="button.id !== 'online'"
              class="custom-btn none"
              size="small"
              @click="handleClick(button, row)"
              >{{ button.text }}</el-button
            >
          </div>
        </template>
        <template #status="{ row }">
          <el-switch
            v-model="row.status"
            active-color="#348CF8"
            inactive-color="#D0D0D0"
            @change="handleStatusChange(row)"
          >
          </el-switch>
        </template>
      </CustomTable>
    </div>

    <!-- 被关注回复内容区 -->
    <div class="tab-content" v-show="activeTab === 'follow'">
      <!-- 开关和描述 -->
      <div
        style="
          background: rgba(52, 140, 248, 0.05);
          border-radius: 5px;
          padding: 10px 10px 1px 15px;
        "
      >
        <h2 style="margin-bottom: 20px;">被关注回复</h2>
        <div class="reply-header">
          <div class="reply-desc">
            <span>当用户关注公众号时，自动发送的回复内容</span>
            <el-button
              type="text"
              size="small"
              class="custom-btn none"
              style="margin-left: 20px"
              >了解更多</el-button
            >
          </div>
          <el-switch
            v-model="followEnabled"
            active-text=""
            inactive-text=""
          ></el-switch>
        </div>
      </div>

      <!-- 回复内容设置 -->
      <div class="follow-content">
        <div
          class="search-buttons"
          style="display: flex; justify-content: flex-end"
        >
          <el-button type="primary" size="small" icon="el-icon-plus" plain
            >新增</el-button
          >
          <el-button type="danger" size="small" icon="el-icon-delete" plain
            >删除</el-button
          >
        </div>
        <div style="margin-top: -40px">
          <el-form :model="followForm" label-width="80px" label-position="top">
            <el-form-item label="回复内容">
              <el-input
                style="margin-top: 20px"
                type="textarea"
                v-model="followForm.content"
                placeholder="请输入被关注时的回复内容"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 左侧活动列表弹窗-->
    <!-- 引入编辑弹窗组件 -->
    <EditDialog
      ref="editDialog"
      :dialogRadius="'15px'"
      :visible="dialogVisible"
      :title="`${title}${activeTab === 'keyword' ? '关键词' : '被关注'}回复`"
      :img-src="require('@/assets/home/admin/home/text_title.png')"
      :fields="formFields"
      :labelPosition="'top'"
      :form-rules="formRules"
      :initial-data="formData"
      :isShowList="['取消', '确认']"
      @update:visible="dialogVisible = $event"
      @confirm="handleConfirm"
      @close="dialogVisible = false"
    >
    </EditDialog>
  </div>
</template>

<script>
import { tableHeaders, actionButtons } from "@/utils/defaultData";
export default {
  name: "WechatAutoReplyIndex",
  data() {
    return {
      title: "",
      dialogVisible: false,
      tableHeaders: tableHeaders.autoReplyTable,
      tableData: [],
      pagination: {
        total: 14,
        currentPage: 1,
        pageSize: 10,
      },
      tableLoading: false,
      activeTab: "keyword",
      keywordEnabled: true,
      followEnabled: true,
      keywordSearch: "",
      currentPage: 1,
      selectedRows: [],
      formData: {
        keyword: "",
        replyContent: "",
        status: true,
      },
      formFields: [
        {
          label: "规则名称",
          prop: "ruleName",
          type: "input",
          placeholder: "请输入规则名称",
        },
        {
          label: "关键词",
          prop: "keyword",
          type: "input",
          placeholder: "请输入关键词",
          // regex: /^[a-z]+$/,
          // regexMsg: "只能输入小写字母（a-z）",
          // filterInput: true,
        },
        {
          label: "回复内容",
          prop: "replyContent",
          type: "textarea",
          placeholder: "请输入回复内容",
          fullWidth: true,
        },
      ],
      formRules: {
        ruleName: [
          {
            required: true,
            message: "请输规则名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      followForm: {
        content:
          "感谢关注星瀚智联科技有限公司！我们致力于为您提供优质的智能解决方案，如有任何问题，欢迎随时咨询。",
      },
    };
  },
  mounted() {
    // 获取关键词回复列表
    this.getKeywordReplyList();
  },
  methods: {
    // 处理确认事件
    handleConfirm(event) {
      console.log("编辑弹窗确认回调", event, this.title);
      if (this.title === "新增") {
        console.log("开始新增了", this.title, this.formData, event);
        this.$api.admin.wechatOfficialAccount
          .createKeywordReplyAPI(event)
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "新增活动成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.getKeywordReplyList();
            }
          });
        return;
      }
      this.$api.admin.wechatOfficialAccount
        .updateKeywordReplyStatusAPI(event)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "修改活动成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.getKeywordReplyList();
          }
        });
      return;
    },
    // 状态修改
    handleStatusChange(row) {
      console.log("状态修改", row);
      this.$api.admin.wechatOfficialAccount
        .updateKeywordReplyStatusAPI(row)
        .then((res) => {
          console.log("状态修改结果", res);
          if (res.code === 200) {
            this.$message({
              message: "状态修改成功",
              type: "success",
            });
          }
          this.getKeywordReplyList();
        });
    },
    // 按钮点击
    handleClick(button, row) {
      console.log("点击了按钮", button, row);
      if (button.id) {
        this.title = button.text;
        console.log("走表格内的按钮逻辑");
        if (button.text === "新增") {
          console.log("走新增");
          this.dialogVisible = true;
        } else if (button.text === "编辑") {
          console.log("走编辑");
          this.formData = row;
          this.dialogVisible = true;
        } else if (button.text === "删除") {
          console.log("走删除");
          this.$modal
            .confirm(`确认删除${row.keyword}关键词吗？`)
            .then(() => {
              this.$api.admin.wechatOfficialAccount
                .deleteKeywordReplyAPI({ keywordIds: [row.keywordId] })
                .then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: "删除成功",
                      type: "success",
                    });
                    this.getKeywordReplyList();
                  }
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        } else {
          console.log("走详情");
        }
        return;
      }
      this.title = row;
      if (row === "搜索") {
        console.log("走搜索逻辑");
        this.getKeywordReplyList();
      } else if (row === "重置") {
        console.log("走重置逻辑");
        this.keywordSearch = "";
        this.getKeywordReplyList();
      } else if (row === "新增") {
        console.log("走新增逻辑");
        this.dialogVisible = true;
      } else {
        console.log("走批量删除逻辑", button, row);
        if (this.selectedRows.length === 0) {
          this.$message({
            type: "warning",
            message: "请选择要删除的记录",
          });
          return;
        }
        this.$modal
          .confirm(`确认删除${this.selectedRows.length}条记录吗？`)
          .then(() => {
            this.$api.admin.wechatOfficialAccount
              .deleteKeywordReplyAPI({
                keywordIds: this.selectedRows.map((item) => item.keywordId),
              })
              .then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });
                  this.getKeywordReplyList();
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 获取关键词回复列表
    getKeywordReplyList() {
      this.tableLoading = true;
      this.$api.admin.wechatOfficialAccount
        .getKeywordReplyListAPI({ keyword: this.keywordSearch })
        .then((res) => {
          console.log("获取关键词回复结果", res);
          if (res.code === 200) {
            this.tableData = res.data;
            //   this.pagination.total = res.data.total;
            this.tableLoading = false;
          }
        });
    },
    // 处理每页显示条数变化
    handleSizeChange(newPagination) {
      console.log("每页条数变化", newPagination);
      this.pagination = newPagination;

      // this.getList();
    },
    // 处理页码变化
    handleCurrentChange(newPagination) {
      this.tableLoading = true;
      console.log("页码变化", newPagination);
      this.tableData = [
        {
          name: "最后加的",
          type: "男",
          image:
            "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
          uploadTime: "2025-09-11 10:00:00",
          uploadUser: "admin",
          status: false,
        },
      ];
      // this.pagination = newPagination;
      // this.getList();
    },
    // 处理选择事件
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log("父组件中选项变更了", this.selectedRows);
    },
  },
};
</script>

<style scoped lang="scss">
.auto-reply-page {
  padding: 10px;
  background-color: #fff;
  height: 100%;

  // 自定义胶囊tab样式
  .custom-tabs {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;

    .tab-item {
      padding: 5px 13px 0;
      border-radius: 999px; // 完全圆角
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid #e4e7ed;
      background-color: #fff;
      color: #333;
      position: relative; // 新增：为下划线定位
      display: flex; // 新增：垂直居中
      flex-direction: column; // 新增：文字和下划线垂直排列
      align-items: center; // 新增：内容水平居中

      // 激活状态样式（完全匹配图片）
      &.active {
        background: linear-gradient(90deg, #409eff 0%, #1890ff 100%);
        color: #fff;
        border-color: #1890ff;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
      }

      // hover效果优化
      &:not(.active):hover {
        border-color: #c6e2ff;
        color: #1890ff;
      }

      // 文字样式
      .tab-text {
        margin-bottom: 4px; // 新增：文字和下划线间距
      }

      // 选中态下划线样式
      .tab-underline {
        width: 24px; // 下划线宽度（可根据需求调整）
        height: 2px; // 下划线高度
        background-color: #fff; // 白色下划线
        border-top-left-radius: 5px; // 轻微圆角，更美观
        border-top-right-radius: 5px; // 轻微圆角，更美观
      }
    }
  }

  // tab内容区样式
  .tab-content {
    background-color: #fff;
    border-radius: 4px;
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    min-height: 400px;
  }

  /* 回复头部 */
  .reply-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .reply-desc {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666;

      .more-info {
        margin-left: 10px;
        color: #1890ff;
      }
    }
  }

  /* 搜索栏 */
  .search-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .search-input {
      display: flex;
      align-items: center;

      span {
        margin-right: 10px;
        font-size: 14px;
        color: #666;
      }

      .el-input {
        margin-right: 10px;
      }

      .el-button {
        margin-right: 10px;
      }
    }

    .search-buttons {
      display: flex;
      gap: 10px;
    }
  }

  /* 表格样式 */
  .el-table {
    margin-bottom: 20px;

    ::v-deep .el-table__header-wrapper th {
      background-color: #f5f7fa;
      font-weight: 600;
      color: #333;
    }

    ::v-deep .el-table__body-wrapper {
      max-height: 400px;
    }

    ::v-deep .el-table-column--selection {
      width: 40px;
    }
  }

  /* 分页样式 */
  .pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    color: #666;

    .total {
      margin-right: 15px;
    }

    .page-size {
      margin-right: 15px;
    }
  }

  /* 被关注回复内容 */
  .follow-content {
    margin-top: 20px;

    .el-form {
      max-width: 800px;

      .el-form-item {
        margin-bottom: 20px;

        .el-textarea {
          width: 100%;
        }
      }
    }
  }
}
</style>
